export const VARIANTS = {
	PRIMARY: 'primary',
	LIGHT: 'light'
};
